import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Router>

    <React.StrictMode>
      <GoogleReCaptchaProvider reCaptchaKey="6LfNlVktAAAAADUBHi53O4BNt6UwEhM8MbNJTogr">
        <App />
      </GoogleReCaptchaProvider>
    </React.StrictMode>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
